export default __webpack_public_path__ + "static/media/Ellipse 15.7b7c24ad.svg";